// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__30wAA","checked":"Checkbox_checked__Qh3J7"};